module.exports = __webpack_public_path__ + "static/portfolio_light_1-1bc3b519e36af1f8c1ae732939d56d44.png";